'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { NavbarIsland } from './NavbarIsland';
import { AnalyticsConsentManager } from './AnalyticsConsentManager';
import { NativeAppLifecycle } from './NativeAppLifecycle';
import { ScrollToTop } from './ScrollToTop';
import { OfflineAccountLifecycle } from './OfflineAccountLifecycle';
import { SharedOutingMapProvider } from '@/app/_components/companion/SharedOutingMapProvider';
import { RecordingHost } from '@/app/_components/companion/RecordingHost';

/** Keep the root server layout static and the public iframe free of account UI. */
export function SiteShell({ children, footer }: { children: ReactNode; footer: ReactNode }) {
  const pathname = usePathname();
  if (pathname === '/embed/conditions') return <RecordingHost><main id="main">{children}</main></RecordingHost>;
  const atlas = pathname === '/conditions/global';
  return <SharedOutingMapProvider><RecordingHost>
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[1100] focus:px-4 focus:py-2 focus:bg-navy focus:text-white focus:rounded-sm focus:text-sm focus:font-semibold">Skip to content</a>
    <AnalyticsConsentManager />
    <NativeAppLifecycle />
    <OfflineAccountLifecycle />
    <ScrollToTop />
    <NavbarIsland />
    <main id="main" className={atlas ? 'h-svh overflow-hidden pt-16' : 'min-h-screen pt-16'}>{children}</main>
    {!atlas && footer}
  </RecordingHost></SharedOutingMapProvider>;
}
